import { showError } from '../assets/js/helpers';
import { setSessionCookie, getCookie, deleteCookie } from '../assets/js/modules/cookies';
let errorTimer = null;
// Pricing
export const pricing = {
  basePrice: {
    single: {
      area: [0, 1000],
      titles: [0, 1],
      price: 10,
    },
    small: {
      area: [1001, 1500],
      titles: [2, 20],
      price: 15,
    },
    medium: {
      area: [1501, 5000],
      titles: [21, 50],
      price: 20,
    },
    large: {
      area: [5001, 10000],
      titles: [51, 100],
      price: 30,
    },
    xlarge: {
      area: [10001, 50000],
      titles: [101, 200],
      price: 40,
    },
    xxlarge: {
      area: [50001, Number.POSITIVE_INFINITY],
      titles: [201, 300],
      price: 60,
    },
  },
  packs: {
    highways: ['planning:colhe', 'planning:colph', 'planning:england_highways', 'transport:highways'],
    planning: ['planning:cil', 'planning:designated_protected_areas', 'planning:planning_applications'],
  },
  groups: {
    lr: {
      layers: [
        {
          label:
            'Includes HMLR Commercial & Corporate Ownership Data, National Polygon Service and Overseas Companies Ownership Data',
        },
      ],
      price: {
        single: {
          area: [0, 1000],
          titles: [0, 1],
          price: 25,
        },
        small: {
          area: [1001, 1500],
          titles: [2, 20],
          price: 35,
        },
        medium: {
          area: [1501, 5000],
          titles: [21, 50],
          price: 50,
        },
        large: {
          area: [5001, 10000],
          titles: [51, 100],
          price: 60,
        },
        xlarge: {
          area: [10001, 50000],
          titles: [101, 200],
          price: 80,
        },
        xxlarge: {
          area: [50001, Number.POSITIVE_INFINITY],
          titles: [201, 300],
          price: 100,
        },
      },
    },
    planning: {
      layers: [
        { label: 'Areas of Outstanding Natural Beauty', class: 'noshow', id: 'aonb_ds', layer: 'aonb' },
        { label: 'Boundaries', layer: 'boundaries' },
        {
          label: 'Coastal Path',
          class: 'noshow hidelayer england',
          id: 'england_coastal_path_ds',
          layer: 'england_coastal_path',
        },
        {
          label: 'Coastal Path',
          class: 'noshow hidelayer wales',
          id: 'wales_coastal_path_ds',
          layer: 'wales_coastal_path',
        },
        { label: 'Cheshire East - Tree Preservation Orders', class: 'cheshire noshow', layer: 'chestpo' },
        { label: 'Cheshire East - Brownfield Register', class: 'cheshire noshow', layer: 'chesbs' },
        { label: 'Cheshire East - Smoke Control Area', class: 'cheshire noshow', layer: 'chessc' },
        { label: 'Cheshire East - Local Plan Strategy', class: 'cheshire noshow', layer: 'cheslp' },
        { label: 'Cheshire East - Minerals', class: 'cheshire noshow', layer: 'chesm' },
        {
          label: 'Cheshire West - Archaeological Potential',
          class: 'cheshirewest noshow',
          layer: 'chesaoap',
        },
        {
          label: 'Cheshire West - Archaeological Zones',
          class: 'cheshirewest noshow',
          layer: 'chesacz',
        },
        {
          label: 'Cheshire West - Conservation Areas',
          class: 'cheshirewest noshow',
          layer: 'cheslca',
        },
        {
          label: 'Cheshire West - Locally Listed Buildings',
          class: 'cheshirewest noshow',
          layer: 'chesllb',
        },
        {
          label: 'Cheshire West - Listed Buildings',
          class: 'cheshirewest noshow',
          layer: 'cheslb',
        },
        {
          label: 'Cheshire West - Planning Applications',
          class: 'cheshirewest noshow',
          layer: 'chesdm',
        },
        { label: 'Cheshire West - TPOs', class: 'cheshirewest noshow', layer: 'cheswtpo' },
        { label: 'City of London - Highways Extent', class: 'noshow col', layer: 'colhe' },
        { label: 'City of London - Privately Maintain Highways', class: 'noshow col', layer: 'colph' },
        { label: 'City of London - Tree Preservation Orders', class: 'noshow col', layer: 'coltpo' },
        {
          label: 'Common Land & Greens',
          class: 'noshow',
          id: 'ne_crow_access_layer_ds',
          layer: 'ne_crow_access_layer',
        },
        {
          label: 'Common Land & Greens (Sec.15)',
          class: 'noshow',
          id: 'ne_crow_section_15_land_ds',
          layer: 'ne_crow_section_15_land',
        },
        { label: 'Community Infrastructure Levy', id: 'cil_ds', layer: 'cil' },
        { label: 'Conservation Areas', class: 'noshow', id: 'conservation_areas_2017_ds', layer: 'conservation' },
        { label: 'Designated Protected Areas', layer: 'designated_protected_areas' },
        {
          label: 'Enterprise Zones',
          class: 'noshow',
          id: 'enterprise_zones_ds',
          layer: 'enterprise_zones',
        },
        { label: 'GLA Article 4', class: 'noshow hidelayer gla', layer: 'gla_article_4' },
        { label: 'GLA Brownfield Sites', class: 'noshow hidelayer gla', layer: 'gla_brownfield' },
        { label: 'GLA Conservation Areas', class: 'noshow hidelayer gla', layer: 'gla_conservation_areas' },
        { label: 'GLA Designated Open Spaces', class: 'noshow hidelayer gla', layer: 'gla_designated_open' },
        { label: 'GLA Housing Zones', class: 'noshow hidelayer gla', layer: 'gla_housing_zones' },
        { label: 'GLA Protected Vistas', class: 'noshow hidelayer gla', layer: 'gla_protected_vistas' },
        { label: 'GLA Site Allocations', class: 'noshow hidelayer gla', layer: 'gla_site_allocations' },
        { label: 'GLA Site of Importance for Nature Conservation', class: 'noshow hidelayer gla' },
        { label: 'GLA Strategic Housing', class: 'noshow hidelayer gla', layer: 'gla_sinc' },
        { label: 'Greenbelt', class: 'noshow', id: 'greenbelt_ds', layer: 'green_belt' },
        { label: 'Listed Building', class: 'noshow', id: 'listed_buildings_ds', layer: 'listed_buildings' },
        { label: 'Parks & Gardens', class: 'noshow', id: 'he_parksandgardens_ds' },
        {
          label: 'Planning Applications',
          layer: 'planning_applications',
          warning: 'Planning applications for the selected search area only',
        },
        { label: 'Public Rights of Way', layer: 'prow' },
        { label: 'Scheduled Monuments', class: 'noshow', id: 'he_scheduledmonuments', layer: 'he_scheduled_monuments' },
        { label: 'Stockport Article 4.1', class: 'stockport noshow', layer: 'stockport_article_4_1' },
        { label: 'Stockport Article 4.2', class: 'stockport noshow', layer: 'stockport_article_4_2' },
        { label: 'Stockport CPOs ', class: 'stockport noshow', layer: 'stockport_compulsory_purchase_orders' },
        { label: 'Stockport Conservation Areas ', class: 'stockport noshow', layer: 'stockport_conservation_areas' },
        { label: 'Stockport Highway Extent ', class: 'stockport noshow', layer: 'stockport_highways_schemes' },
        // { label: 'Stockport Section 106', class: 'stockport noshow', layer: 'stockport_section106_landcharge' },
        { label: 'Stockport Smoke Control ', class: 'stockport noshow', layer: 'stockport_smoke_control_area' },
        { label: 'Stockport TPO', class: 'stockport noshow', layer: 'stockport_tpo_combined' },
        { label: 'West Dorset Article 4', class: 'westdorset noshow', layer: 'west_dorset_article_4' },
        { label: 'West Dorset TPOs', class: 'westdorset noshow', layer: 'west_dorset_tpo' },
      ],
      price: {
        single: {
          area: [0, 1000],
          titles: [0, 1],
          price: 25,
          each: 3,
        },
        small: {
          area: [1001, 1500],
          titles: [2, 20],
          price: 35,
          each: 4,
        },
        medium: {
          area: [1501, 5000],
          titles: [21, 50],
          price: 50,
          each: 5,
        },
        large: {
          area: [5001, 10000],
          titles: [51, 100],
          price: 60,
          each: 6,
        },
        xlarge: {
          area: [10001, 50000],
          titles: [101, 200],
          price: 80,
          each: 7,
        },
        xxlarge: {
          area: [50001, Number.POSITIVE_INFINITY],
          titles: [201, 300],
          price: 100,
          each: 9,
        },
      },
    },
    flood: {
      layers: [
        { label: 'CA Abandoned Mines Catalogue', class: 'coal noshow', layer: 'abandoned_mines' },
        { label: 'CA Development High Risk Area', class: 'coal noshow', layer: 'dev_high' },
        { label: 'CA Mine Entries', class: 'coal noshow', layer: 'mine_entry' },
        { label: 'Cheshire Brine Area', class: 'cheshire noshow', layer: 'chesbrine' },
        { label: 'EA Historic Flood Outlines', class: 'hidelayer england', layer: 'historic_flood_outlines' },
        { label: 'EA Historic Flood Outlines', class: 'hidelayer wales', layer: 'historic_flood_outlines_wales' },
        { label: 'EA RoFras (Flood Zones)', layer: 'flood_zones' },
        { label: 'EA Surface Water Flooding', class: 'hidelayer england', layer: 'surface_water_flooding' },
        {
          label: 'Historical Landfill Sites',
          class: 'noshow',
          id: 'historic_landfill_sites_ds',
          layer: 'historic_landfill',
        },
        {
          label: 'Local Nature Reserves',
          class: 'noshow hidelayer england',
          id: 'local-nature-reserves-england_ds',
          layer: 'local_nature_reserves_england',
        },
        {
          label: 'Local Nature Reserves',
          class: 'noshow hidelayer wales',
          id: 'NRW_LNR_ds',
          layer: 'local_nature_reserves_wales',
        },
        {
          label: 'National Nature Reserves',
          class: 'noshow hidelayer england',
          id: 'national-nature-reserves-england_ds',
          layer: 'national_nature_reserves_england',
        },
        {
          label: 'National Nature Reserves',
          class: 'noshow hidelayer wales',
          id: 'NRW_NNR_ds',
          layer: 'national_nature_reserves_wales',
        },
        {
          label: 'Permitted Waste/Landfill',
          class: 'noshow',
          id: 'authorised_landfill_sites_ds',
          layer: 'permitted_waste',
        },
        { label: 'Radon', layer: 'radon' },
        {
          label: 'Site of Specific Scientific Interest (SSSI)',
          class: 'noshow',
          id: 'sssi_england_and_wales_ds',
          layer: 'sssi',
        },
        {
          label: 'Special Areas of Conservation',
          class: 'noshow hidelayer england',
          id: 'special-areas-of-conservation-england_ds',
          layer: 'special_areas_of_conservation_england',
        },
        {
          label: 'Special Areas of Conservation',
          class: 'noshow hidelayer wales',
          id: 'NRW_SAC_ds',
          layer: 'special_areas_of_conservation_wales',
        },
        {
          label: 'Special Protection Areas',
          class: 'noshow hidelayer england',
          id: 'special-protection-areas-england_ds',
          layer: 'special_protection_areas_england',
        },
        {
          label: 'Special Protection Areas',
          class: 'noshow hidelayer wales',
          id: 'NRW_SPA_ds',
          layer: 'special_protection_areas_wales',
        },
      ],
      price: {
        single: {
          area: [0, 1000],
          titles: [0, 1],
          price: 15,
          each: 3,
        },
        small: {
          area: [1001, 1500],
          titles: [2, 20],
          price: 25,
          each: 4,
        },
        medium: {
          area: [1501, 5000],
          titles: [21, 50],
          price: 35,
          each: 5,
        },
        large: {
          area: [5001, 10000],
          titles: [51, 100],
          price: 45,
          each: 6,
        },
        xlarge: {
          area: [10001, 50000],
          titles: [101, 200],
          price: 50,
          each: 7,
        },
        xxlarge: {
          area: [50001, Number.POSITIVE_INFINITY],
          titles: [201, 300],
          price: 60,
          each: 9,
        },
      },
    },
    transport: {
      layers: [
        { label: 'Crossrail', class: 'noshow', id: 'crossrail_ds', layer: 'crossrail' },
        { label: 'Docklands Light Railway', class: 'noshow', id: 'dlr_ds', layer: 'dlr' },
        {
          label: 'Highways England',
          class: 'noshow england hidelayer',
          id: 'england_highways_ds',
          layer: 'england_highways',
        },
        { label: 'HS2', class: 'noshow', id: 'hs2_ds', layer: 'hs2' },
        { label: 'London Underground', class: 'noshow', id: 'underground_ds', layer: 'underground' },
        { label: 'Mail Rail', class: 'noshow', id: 'mailrail_ds', layer: 'mailrail' },
        {
          label: 'Highways (Ordnance Survey)',
          layer: 'highways',
          warning:
            "Highways (Ordnance Survey) layer provides confirmation of maintenance responsibility only and doesn't provide the extent",
        },
        { label: 'Thames Tideway Tunnel', class: 'noshow', id: 'tideway_ds', layer: 'thames_tideway_tunnel' },
        { label: 'Utilities (LineSearchBUD)', layer: 'lineSearch' },
      ],
      price: {
        single: {
          area: [0, 1000],
          titles: [0, 1],
          price: 15,
          each: 3,
        },
        small: {
          area: [1001, 1500],
          titles: [2, 20],
          price: 20,
          each: 4,
        },
        medium: {
          area: [1501, 5000],
          titles: [21, 50],
          price: 25,
          each: 5,
        },
        large: {
          area: [5001, 10000],
          titles: [51, 100],
          price: 30,
          each: 6,
        },
        xlarge: {
          area: [10001, 50000],
          titles: [101, 200],
          price: 35,
          each: 7,
        },
        xxlarge: {
          area: [50001, Number.POSITIVE_INFINITY],
          titles: [201, 300],
          price: 50,
          each: 9,
        },
      },
    },
    all: {
      layers: [
        { label: 'Areas of Outstanding Natural Beauty', class: 'noshow', id: 'aonb_ds_all' },
        { label: 'Boundaries' },
        { label: 'CA Development High Risk Area', class: 'coal noshow' },
        { label: 'CA Mine Entries', class: 'coal noshow' },
        { label: 'CA Abandoned Mines Catalogue', class: 'coal noshow' },
        { label: 'Cheshire Brine Area', class: 'cheshire noshow' },
        { label: 'Cheshire East - Tree Preservation Orders', class: 'cheshire noshow' },
        { label: 'Cheshire East - Brownfield Register', class: 'cheshire noshow' },
        { label: 'Cheshire East - Smoke Control Area', class: 'cheshire noshow' },
        { label: 'Cheshire East - Local Plan Strategy', class: 'cheshire noshow' },
        { label: 'Cheshire East - Minerals', class: 'cheshire noshow' },
        { label: 'City of London - Highways Extent', class: 'noshow col' },
        { label: 'City of London - Tree Preservation Orders', class: 'noshow col' },
        { label: 'City of London - Privately Maintain Highways', class: 'noshow col' },
        { label: 'Coastal Path', class: 'noshow hidelayer england', id: 'england_coastal_path_ds_all' },
        { label: 'Coastal Path', class: 'noshow hidelayer wales', id: 'wales_coastal_path_ds_all' },
        { label: 'Common Land & Greens', class: 'noshow', id: 'ne_crow_access_layer_ds_all' },
        { label: 'Common Land & Greens (Sec.15)', class: 'noshow', id: 'ne_crow_section_15_land_ds_all' },
        { label: 'Community Infrastructure Levy', id: 'cil_ds_all' },
        { label: 'Conservation Areas', class: 'noshow', id: 'conservation_areas_2017_ds_all' },
        { label: 'Crossrail', class: 'noshow', id: 'crossrail_ds_all' },
        { label: 'Designated Protected Areas' },
        { label: 'Docklands Light Railway', class: 'noshow', id: 'dlr_ds_all' },
        { label: 'EA Recorded Flood Outlines', class: 'noshow hidelayer england' },
        { label: 'EA RoFras (Flood Zones)' },
        { label: 'EA Surface Water Flooding', class: 'noshow hidelayer england' },
        { label: 'GLA Article 4', class: 'noshow hidelayer gla' },
        { label: 'GLA Brownfield Sites', class: 'noshow hidelayer gla' },
        { label: 'GLA Conservation Areas', class: 'noshow hidelayer gla' },
        { label: 'GLA Designated Open Spaces', class: 'noshow hidelayer gla' },
        { label: 'GLA Housing Zones', class: 'noshow hidelayer gla' },
        { label: 'GLA Protected Vistas', class: 'noshow hidelayer gla' },
        { label: 'GLA Site Allocations', class: 'noshow hidelayer gla' },
        { label: 'GLA Site of Importance for Nature Conservation', class: 'noshow hidelayer gla' },
        { label: 'GLA Strategic Housing', class: 'noshow hidelayer gla' },
        { label: 'Greenbelt', class: 'noshow', id: 'greenbelt_ds_all' },
        { label: 'Historical Landfill Sites', class: 'noshow', id: 'historic_landfill_sites_ds_all' },
        { label: 'Highways England', class: 'noshow england hidelayer', id: 'england_highways_ds_all' },
        { label: 'HS2', class: 'noshow', id: 'hs2_ds_all' },
        { label: 'HMLR Commercial & Corporate Ownership Data' },
        { label: 'HMLR National Polygon Service' },
        { label: 'HMLR Overseas Companies Ownership Data' },
        { label: 'Listed Building', class: 'noshow', id: 'listed_buildings_ds_all' },
        {
          label: 'Local Nature Reserves',
          class: 'noshow hidelayer england',
          id: 'local-nature-reserves-england_ds_all',
        },
        { label: 'Local Nature Reserves', class: 'noshow hidelayer wales', id: 'NRW_LNR_ds_all' },
        { label: 'London Underground', class: 'noshow', id: 'underground_ds_all' },
        { label: 'Mail Rail', class: 'noshow', id: 'mailrail_ds_all' },
        {
          label: 'National Nature Reserves',
          class: 'noshow hidelayer england',
          id: 'national-nature-reserves-england_ds_all',
        },
        {
          label: 'National Nature Reserves',
          class: 'noshow hidelayer wales',
          id: 'NRW_NNR_ds_all',
        },
        { label: 'Stockport Article 4.1', class: 'stockport noshow' },
        { label: 'Stockport Article 4.2', class: 'stockport noshow' },
        { label: 'Stockport CPOs ', class: 'stockport noshow' },
        { label: 'Stockport Conservation Areas ', class: 'stockport noshow' },
        { label: 'Stockport Highways Schemes ', class: 'stockport noshow' },
        { label: 'Stockport Section 106', class: 'stockport noshow' },
        { label: 'Stockport Smoke Control ', class: 'stockport noshow' },
        { label: 'Stockport TPO', class: 'stockport noshow' },
        { label: 'OS MM Highways' },
        { label: 'Parks & Gardens', class: 'noshow', id: 'he_parksandgardens_ds_all' },
        { label: 'Permitted Waste/Landfill', class: 'noshow', id: 'authorised_landfill_sites_ds_all' },
        { label: 'Planning Applications' },
        { label: 'Public Rights of Way' },
        { label: 'Radon' },
        { label: 'Scheduled Monuments', class: 'noshow', id: 'he_scheduledmonuments' },
        { label: 'Site of Specific Scientific Interest (SSSI)', class: 'noshow', id: 'sssi_england_and_wales_ds_all' },
        {
          label: 'Special Areas of Conservation',
          class: 'noshow hidelayer england',
          id: 'special-areas-of-conservation-england_ds_all',
        },
        {
          label: 'Special Areas of Conservation',
          class: 'noshow hidelayer wales',
          id: 'NRW_SAC_ds_all',
        },
        {
          label: 'Special Protection Areas',
          class: 'noshow hidelayer england',
          id: 'special-protection-areas-england_ds_all',
        },
        {
          label: 'Special Protection Areas',
          class: 'noshow hidelayer wales',
          id: 'NRW_SPA_ds_all',
        },
        { label: 'Thames Tideway Tunnel', class: 'noshow', id: 'tideway_ds' },
        { label: 'Utilities' },
        { label: 'West Dorset Article 4', class: 'westdorset noshow', layer: 'west_dorset_article_4' },
        { label: 'West Dorset TPOs', class: 'westdorset noshow', layer: 'west_dorset_tpo' },
      ],
      price: {
        single: {
          area: [0, 1000],
          titles: [0, 1],
          price: 60,
        },
        small: {
          area: [1001, 1500],
          titles: [2, 20],
          price: 95,
        },
        medium: {
          area: [1501, 5000],
          titles: [21, 50],
          price: 125,
        },
        large: {
          area: [5001, 10000],
          titles: [51, 100],
          price: 145,
        },
        xlarge: {
          area: [10001, 50000],
          titles: [101, 200],
          price: 175,
        },
        xxlarge: {
          area: [50001, Number.POSITIVE_INFINITY],
          titles: [201, 300],
          price: 225,
        },
      },
    },
    extended: {
      layers: [{ label: "Additional option to extend Planning App's to include a 75m Buffer from the search area" }],
      price: {
        single: {
          area: [0, 1000],
          titles: [0, 1],
          price: 20,
        },
        small: {
          area: [1001, 1500],
          titles: [2, 20],
          price: 30,
        },
        medium: {
          area: [1501, 5000],
          titles: [21, 50],
          price: 50,
        },
        large: {
          area: [5001, 10000],
          titles: [51, 100],
          price: 60,
        },
        xlarge: {
          area: [10001, 50000],
          titles: [101, 200],
          price: 80,
        },
        xxlarge: {
          area: [50001, Number.POSITIVE_INFINITY],
          titles: [201, 300],
          price: 100,
        },
      },
    },
  },
};
const getPrice = (grp, area, parcels) => {
  area = Math.ceil(area);
  let bp1 = Object.keys(pricing.groups[grp].price)
    .map(e => pricing.groups[grp].price[e])
    .find(p => area >= p.area[0] && area <= p.area[1]).price;
  let bp2 = Object.keys(pricing.groups[grp].price)
    .map(e => pricing.groups[grp].price[e])
    .find(p => parcels >= p.titles[0] && parcels <= p.titles[1]).price;
  return bp1 > bp2 ? bp1 : bp2;
};
const getBasePrice = (area, parcels) => {
  area = Math.ceil(area);
  let bp1 = Object.keys(pricing.basePrice)
    .map(e => pricing.basePrice[e])
    .find(p => area >= p.area[0] && area <= p.area[1]).price;
  let bp2 = Object.keys(pricing.basePrice)
    .map(e => pricing.basePrice[e])
    .find(p => parcels >= p.titles[0] && parcels <= p.titles[1]).price;
  return bp1 > bp2 ? bp1 : bp2;
};
const getLayerPrice = (grp, area, parcels) => {
  area = Math.ceil(area);
  let lp1 = Object.keys(pricing.groups[grp].price)
    .map(e => pricing.groups[grp].price[e])
    .find(p => area >= p.area[0] && area <= p.area[1]).each;
  let lp2 = Object.keys(pricing.groups[grp].price)
    .map(e => pricing.groups[grp].price[e])
    .find(p => parcels >= p.titles[0] && parcels <= p.titles[1]).each;
  return lp1 > lp2 ? lp1 : lp2;
};
export const calculatePrice = ({ groups, area, layers = [], parcels }) => {
  let price = 0;
  let baseAdded = false;
  let totalLayerPrice = 0;
  let layerPrice = 0;
  if (!groups.length && !layers.length) {
    return { price: 0, layerPrice: 0 };
  }
  if (
    groups.includes('all') ||
    (groups.includes('planning') && groups.includes('lr') && groups.includes('flood') && groups.includes('transport'))
  ) {
    price = getPrice('all', area, parcels);
    if (groups.includes('extended')) {
      price += getPrice('extended', area, parcels);
    }
  } else {
    groups.forEach(g => {
      const p = getPrice(g, area, parcels);
      price += p;
      totalLayerPrice += p;
      layerPrice = getLayerPrice(g, area, parcels);
    });
    layers.forEach(l => {
      const lp = getLayerPrice(l.split(':')[0], area, parcels);
      price += lp;
      totalLayerPrice += lp;
    });
    if (groups.length === 0 && !baseAdded) {
      price += getBasePrice(area, parcels);
      baseAdded = true;
    }
  }
  return { price, layerPrice, totalLayerPrice, baseAdded };
};
export const recalculatePrice = state => {
  const { price } = calculatePrice({
    groups: state.snapshotGroups,
    layers: state.snapshotLayers,
    area: state.snapshotFeatures[0].geometry.getArea(),
    parcels: state.parcelCount,
  });
  $('#subtotal').text(price.toString());
  if (price) $('#snapshot_next').removeAttr('disabled');
  else $('#snapshot_next').attr('disabled', true);

  let checkPrice = price;
  if (state.snapshotGroups.includes('extended'))
    checkPrice -= calculatePrice({
      groups: ['extended'],
      area: state.snapshotFeatures[0].geometry.getArea(),
      parcels: state.parcelCount,
    }).price;
  if (state.allPrice < checkPrice) {
    const cheaper = getCookie('cheaperSeen');
    if (!cheaper) {
      errorTimer = setTimeout(() => {
        showError({
          state,
          title: 'Cost Saving',
          message:
            "Choosing 'All Layers' would be a cheaper option<p /><input type='checkbox' id='cheaper' /> Do not show me this message again",
        });
        $('#cheaper')
          .off()
          .on('click', e => {
            if (e.currentTarget.checked) setSessionCookie('cheaperSeen', true);
            else deleteCookie('cheaperSeen');
          });
      }, 200);
    }
  } else {
    clearTimeout(errorTimer);
  }
};
